import resources from "../../core/Localization/Localization";
import { getDateString } from "../../utils/getDateString";

export const versionColumns = () => [
    {
        field: "id",
        headerName: "ID",
        filter: true,
        sort: true,
        filterType: "textField",
        flex: 1
    },
    {
        field: "app_name",
        headerName: resources.versionList.datagrid.app_name,
        filter: true,
        sort: true,
        filterType: "textField",
        flex: 1
    },
    {
        field: "version",
        headerName: resources.versionList.datagrid.version,
        filter: true,
        sort: true,
        filterType: "textField",
        flex: 1
    },
    {
        field: "build_number",
        headerName: resources.versionList.datagrid.build_number,
        filter: true,
        sort: true,
        filterType: "textField",
        flex: 1
    },
    {
        field: "platform",
        headerName: resources.versionList.datagrid.platform,
        filter: true,
        sort: true,
        filterType: "textField",
        flex: 1
    },
    {
        field: "release_type",
        headerName: resources.versionList.datagrid.release_type,
        filter: true,
        sort: true,
        filterType: "textField",
        flex: 1
    },
    {
        field: "release_status",
        headerName: resources.versionList.datagrid.release_status,
        filter: true,
        sort: true,
        filterType: "textField",
        flex: 1
    },
    {
        field: "createdAt",
        headerName: resources.partRequests.datagrid.created,
        filter: true,
        sort: true,
        filterType: "textField",
        flex: 1,
        valueGetter: (value) => getDateString(value)
    }
];
